// theme.ts (Version 2 needs to be a tsx file, due to usage of StyleFunctions)
import { extendTheme } from '@chakra-ui/react'
import { mode } from '@chakra-ui/theme-tools'

// Version 1: Using objects
const theme = extendTheme({
  config: {
    initialColorMode: 'light',
    useSystemColorMode: false,
  },
  fonts: {
    heading: `'Inter', 'Montserrat', sans-serif`,
    body: `'Inter', 'Montserrat', sans-serif`,
  },
  colors: {
    brand: {
      50: '#fffbeb',
      100: '#fef3c7',
      200: '#fde68a',
      300: '#fcd34d',
      400: '#fbbf24',
      500: '#f59e0b', // Amber/Yellow primary
      600: '#d97706',
      700: '#b45309',
      800: '#92400e',
      900: '#78350f',
    },
    accent: {
      50: '#fafaf9',
      100: '#f5f5f4',
      200: '#e7e5e4',
      300: '#d6d3d1',
      400: '#a8a29e',
      500: '#78716c', // Slate/Stone accent
      600: '#57534e',
      700: '#44403c',
      800: '#292524',
      900: '#1c1917',
    },
    dark: {
      50: '#2d3436',
      100: '#212529',
      200: '#161a1d',
      300: '#0b090a',
      400: '#050505',
    }
  },
  styles: {
    global: (props) => ({
      body: {
        fontFamily: 'body',
        color: mode('gray.800', 'whiteAlpha.900')(props),
        bg: mode('#f8fafc', '#0f172a')(props),
        lineHeight: 'base',
      },
      '*::placeholder': {
        color: mode('gray.400', 'whiteAlpha.400')(props),
      },
      '::selection': {
        bg: 'brand.200',
        color: 'brand.900',
      },
    }),
  },
  components: {
    Button: {
      baseStyle: {
        borderRadius: 'xl',
        fontWeight: '600',
        transition: 'all 0.2s cubic-bezier(.08,.52,.52,1)',
      },
      variants: {
        solid: (props) => ({
          bg: props.colorScheme === 'brand' ? 'brand.500' : undefined,
          color: 'white',
          _hover: {
            bg: props.colorScheme === 'brand' ? 'brand.600' : undefined,
            transform: 'translateY(-2px)',
            boxShadow: 'lg',
          },
          _active: {
            transform: 'translateY(0)',
          }
        }),
        glass: (props) => ({
          bg: mode('rgba(255, 255, 255, 0.1)', 'rgba(255, 255, 255, 0.05)')(props),
          backdropFilter: 'blur(10px)',
          border: '1px solid',
          borderColor: mode('whiteAlpha.300', 'whiteAlpha.100')(props),
          _hover: {
            bg: mode('whiteAlpha.300', 'whiteAlpha.200')(props),
          }
        })
      }
    },
    Input: {
      variants: {
        filled: (props) => ({
          field: {
            borderRadius: 'xl',
            bg: mode('gray.100', 'whiteAlpha.50')(props),
            border: '2px solid transparent',
            _focus: {
              bg: mode('white', 'whiteAlpha.100')(props),
              borderColor: 'brand.500',
            }
          }
        }),
        outline: {
          field: {
            borderRadius: 'xl',
            _focus: {
              borderColor: 'brand.500',
              boxShadow: '0 0 0 1px var(--chakra-colors-brand-500)',
            }
          }
        }
      },
      defaultProps: {
        variant: 'outline',
      }
    },
    Card: {
      baseStyle: (props) => ({
        container: {
          borderRadius: '2xl',
          bg: mode('white', 'whiteAlpha.50')(props),
          boxShadow: 'xl',
          border: '1px solid',
          borderColor: mode('gray.100', 'whiteAlpha.100')(props),
          overflow: 'hidden',
        }
      })
    }
  },
  breakpoints: {
    sm: '320px',
    xsm: '500px',
    md: '800px',
    lg: '960px',
    xl: '1200px',
  }
})

 export default theme;


// import { extendTheme } from '@chakra-ui/react'

// const customTheme = {
//   components: {
//     Text: {
//       variants: {
//         subtitle: {
//           color: 'gray.500',
//           fontWeight: '14px',
//         },
//       }
//     }
//   },
//   // styles: {
//   //   global: (props) => ({
//   //     'html, body': {
//   //       fontSize: 'sm',
//   //       backgroundColor: props.colorMode === 'dark' ? 'white' : 'gray.600',
//   //       lineHeight: 'tall',
//   //     },
//   //     a: {
//   //       color: props.colorMode === 'dark' ? 'teal.300' : 'teal.500',
//   //     },
//   //   }),
//   // },


// };

// const breakpoints = {
//     sm: '320px',
//     xsm:'500px',
//     md: '800px',
//     lg: '960px',
//     xl: '1200px',
//   }

// const theme = extendTheme(customTheme, {breakpoints});

// export default theme;